import React from "react";
import "../Industries.css";
import Footer from "../../../components/Footer";
import Header from "../../../components/Header";
import { FaArrowRight, FaArrowDown } from "react-icons/fa";
import { Link } from "react-router-dom";

const Industries = () => {
  return (

    <>
      <Header />
      <title>VisionVote Technologies | Empowering Industries with Intelligent Technology</title>
      <div className="industries-page">

        {/* ================= HERO ================= */}

        <section className="industries-hero">

          <div className="industries-overlay"></div>

          <div className="container industries-hero-content">

            <span className="hero-badge">
              INDUSTRY EXPERTISE • DIGITAL TRANSFORMATION • SOFTWARE SOLUTIONS
            </span>

            <h1>
              Empowering Industries with
              <span> Intelligent Technology</span>
            </h1>

            <p>
              VisionVote Technologies Private Limited partners with startups,
              enterprises, and organizations across diverse industries to build
              innovative software solutions that improve efficiency, accelerate
              digital transformation, and drive sustainable business growth.
            </p>

            <div className="hero-buttons">

              <button className="primary-btn">
                Explore Industries
                <FaArrowDown />
              </button>

             
                <button className="secondary-btn" onClick={() => window.location.href = '/contact'}>

                  Contact Experts
                  <FaArrowRight />

                </button>
              

            </div>

          </div>

        </section>

        {/* ================= INTRODUCTION ================= */}

        <section className="industries-intro">

          <div className="container industries-intro-grid">

            {/* LEFT */}

            <div className="intro-content">

              <span className="section-tag">
                INDUSTRIES WE SERVE
              </span>

              <h2>
                Technology Solutions Tailored
                <span> For Every Industry</span>
              </h2>

              <p>
                Every industry has unique challenges, evolving customer
                expectations, and rapidly changing technologies. At VisionVote
                Technologies, we combine deep technical expertise with industry
                insights to create scalable, secure, and intelligent digital
                solutions that help businesses stay competitive.
              </p>

              <p>
                From healthcare and finance to manufacturing, education,
                logistics, retail, and emerging startups, we design and develop
                innovative platforms that streamline operations, enhance customer
                experiences, automate workflows, and unlock new business
                opportunities.
              </p>

              <div className="industry-highlights">

                <div>✓ Industry-Specific Solutions</div>

                <div>✓ Secure & Scalable Platforms</div>

                <div>✓ AI-Powered Innovation</div>

                <div>✓ Cloud-Native Architecture</div>

                <div>✓ Digital Transformation</div>

                <div>✓ End-to-End Consulting</div>

              </div>

            </div>

            {/* RIGHT */}

            <div className="intro-image">

              <svg
                viewBox="0 0 700 520"
                xmlns="http://www.w3.org/2000/svg"
              >

                <defs>

                  <linearGradient
                    id="industryGradient"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                  >

                    <stop offset="0%" stopColor="#2563eb" />

                    <stop offset="100%" stopColor="#60a5fa" />

                  </linearGradient>

                </defs>

                <circle
                  cx="570"
                  cy="90"
                  r="60"
                  fill="#DBEAFE"
                />

                <circle
                  cx="150"
                  cy="430"
                  r="70"
                  fill="#E0F2FE"
                />

                <rect
                  x="120"
                  y="80"
                  width="460"
                  height="320"
                  rx="24"
                  fill="url(#industryGradient)"
                />

                <rect
                  x="150"
                  y="110"
                  width="400"
                  height="260"
                  rx="18"
                  fill="#fff"
                />

                {/* Industry Cards */}

                <rect
                  x="185"
                  y="150"
                  width="90"
                  height="80"
                  rx="14"
                  fill="#2563eb"
                />

                <rect
                  x="305"
                  y="150"
                  width="90"
                  height="80"
                  rx="14"
                  fill="#60A5FA"
                />

                <rect
                  x="425"
                  y="150"
                  width="90"
                  height="80"
                  rx="14"
                  fill="#BFDBFE"
                />

                <rect
                  x="185"
                  y="255"
                  width="90"
                  height="80"
                  rx="14"
                  fill="#60A5FA"
                />

                <rect
                  x="305"
                  y="255"
                  width="90"
                  height="80"
                  rx="14"
                  fill="#2563eb"
                />

                <rect
                  x="425"
                  y="255"
                  width="90"
                  height="80"
                  rx="14"
                  fill="#93C5FD"
                />

              </svg>

            </div>

          </div>

        </section>

        {/* ================= INDUSTRIES GRID ================= */}

        <section className="industries-grid-section">

          <div className="container">

            <span className="section-tag">
              INDUSTRIES WE EMPOWER
            </span>

            <h2>
              Delivering Digital Innovation Across
              <span> Multiple Industries</span>
            </h2>

            <p className="industries-grid-text">
              We build scalable, secure, and intelligent software solutions tailored to
              the unique challenges of various industries, helping businesses innovate,
              automate, and accelerate growth.
            </p>

            <div className="industries-grid">

              <div className="industry-card">
                <div className="industry-icon">🏥</div>
                <h3>Healthcare</h3>
                <p>
                  Hospital Management, Telemedicine, Patient Portals, EHR and Healthcare Analytics.
                </p>
              </div>

              <div className="industry-card">
                <div className="industry-icon">🏦</div>
                <h3>Banking & Finance</h3>
                <p>
                  Digital Banking, FinTech Platforms, Payment Solutions and Secure Transactions.
                </p>
              </div>

              <div className="industry-card">
                <div className="industry-icon">🛒</div>
                <h3>Retail & eCommerce</h3>
                <p>
                  Online Stores, POS Systems, Inventory Management and Customer Engagement.
                </p>
              </div>

              <div className="industry-card">
                <div className="industry-icon">🎓</div>
                <h3>Education</h3>
                <p>
                  Learning Management Systems, Student Portals and Online Examination Platforms.
                </p>
              </div>

              <div className="industry-card">
                <div className="industry-icon">🏭</div>
                <h3>Manufacturing</h3>
                <p>
                  ERP Systems, Production Automation, Quality Monitoring and Analytics.
                </p>
              </div>

              <div className="industry-card">
                <div className="industry-icon">🚚</div>
                <h3>Logistics</h3>
                <p>
                  Fleet Management, Shipment Tracking, Warehouse Solutions and Route Planning.
                </p>
              </div>

              <div className="industry-card">
                <div className="industry-icon">🏢</div>
                <h3>Real Estate</h3>
                <p>
                  Property Management, CRM, Lead Automation and Smart Real Estate Solutions.
                </p>
              </div>

              <div className="industry-card">
                <div className="industry-icon">🍽</div>
                <h3>Hospitality</h3>
                <p>
                  Hotel Management, Restaurant POS, Booking Systems and Guest Experience.
                </p>
              </div>

              <div className="industry-card">
                <div className="industry-icon">⚖</div>
                <h3>Legal Services</h3>
                <p>
                  Case Management, Document Automation, Client Portals and Billing Systems.
                </p>
              </div>

              <div className="industry-card">
                <div className="industry-icon">🌾</div>
                <h3>Agriculture</h3>
                <p>
                  Smart Farming, Supply Chain, IoT Monitoring and Agricultural Analytics.
                </p>
              </div>

              <div className="industry-card">
                <div className="industry-icon">🏛</div>
                <h3>Government</h3>
                <p>
                  e-Governance Platforms, Citizen Services, Automation and Digital Records.
                </p>
              </div>

              <div className="industry-card">
                <div className="industry-icon">🚀</div>
                <h3>Startups</h3>
                <p>
                  MVP Development, SaaS Platforms, Cloud Infrastructure and Product Engineering.
                </p>
              </div>

            </div>

          </div>

        </section>

        {/* ================= HEALTHCARE SOLUTIONS ================= */}

        <section className="industry-detail healthcare-section">

          <div className="container industry-detail-grid">

            {/* LEFT CONTENT */}

            <div className="industry-content">

              <span className="section-tag">
                HEALTHCARE INDUSTRY
              </span>

              <h2>
                Smart Healthcare Solutions for
                <span> Modern Patient Care</span>
              </h2>

              <p>
                VisionVote Technologies develops secure, scalable, and intelligent
                healthcare software that empowers hospitals, clinics, diagnostic
                centers, pharmacies, and healthcare startups to improve operational
                efficiency while delivering exceptional patient experiences.
              </p>

              <p>
                Our healthcare platforms simplify clinical workflows, enable digital
                patient engagement, automate hospital operations, and ensure secure
                access to healthcare information while supporting regulatory
                compliance and future-ready innovation.
              </p>

              <div className="industry-features">

                <div>✓ Hospital Management System</div>

                <div>✓ Electronic Health Records (EHR)</div>

                <div>✓ Telemedicine Platforms</div>

                <div>✓ Appointment Scheduling</div>

                <div>✓ Patient Portal</div>

                <div>✓ Pharmacy Management</div>

                <div>✓ Medical Billing</div>

                <div>✓ Healthcare Analytics</div>

              </div>

              <a href="/contact" style={{ textDecoration: "none", color: "inherit" }}>
                <button className="industry-btn">
                  Build Healthcare Solution →
                </button>
              </a>

            </div>

            {/* RIGHT SVG */}

            <div className="industry-image">

              <svg
                viewBox="0 0 700 520"
                xmlns="http://www.w3.org/2000/svg"
              >

                <defs>

                  <linearGradient
                    id="healthGradient"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                  >

                    <stop offset="0%" stopColor="#2563eb" />

                    <stop offset="100%" stopColor="#60a5fa" />

                  </linearGradient>

                </defs>

                {/* Background */}

                <circle cx="560" cy="90" r="55" fill="#DBEAFE" />

                <circle cx="130" cy="430" r="70" fill="#E0F2FE" />

                {/* Monitor */}

                <rect
                  x="180"
                  y="90"
                  width="340"
                  height="250"
                  rx="22"
                  fill="url(#healthGradient)"
                />

                <rect
                  x="205"
                  y="115"
                  width="290"
                  height="200"
                  rx="14"
                  fill="#fff"
                />

                {/* Medical Cross */}

                <rect
                  x="325"
                  y="155"
                  width="50"
                  height="120"
                  rx="10"
                  fill="#2563eb"
                />

                <rect
                  x="290"
                  y="190"
                  width="120"
                  height="50"
                  rx="10"
                  fill="#2563eb"
                />

                {/* Heartbeat */}

                <polyline

                  points="225,245 255,245 275,215 300,270 330,205 355,245 470,245"

                  fill="none"

                  stroke="#60A5FA"

                  strokeWidth="6"

                  strokeLinecap="round"

                  strokeLinejoin="round"

                />

                {/* Stand */}

                <rect

                  x="330"

                  y="340"

                  width="40"

                  height="45"

                  rx="8"

                  fill="#94A3B8"

                />

                <rect

                  x="250"

                  y="385"

                  width="200"

                  height="18"

                  rx="9"

                  fill="#64748B"

                />

              </svg>

            </div>


          </div>

        </section>

        {/* ================= BANKING & FINANCE ================= */}

        <section className="industry-detail banking-section">

          <div className="container industry-detail-grid">

            {/* LEFT SVG */}

            <div className="industry-image">

              <svg
                viewBox="0 0 700 520"
                xmlns="http://www.w3.org/2000/svg"
              >

                <defs>

                  <linearGradient
                    id="bankGradient"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                  >

                    <stop offset="0%" stopColor="#2563eb" />

                    <stop offset="100%" stopColor="#60a5fa" />

                  </linearGradient>

                </defs>

                <circle cx="560" cy="90" r="55" fill="#DBEAFE" />
                <circle cx="130" cy="420" r="70" fill="#E0F2FE" />

                {/* Dashboard */}

                <rect
                  x="150"
                  y="80"
                  width="400"
                  height="280"
                  rx="22"
                  fill="url(#bankGradient)"
                />

                <rect
                  x="175"
                  y="105"
                  width="350"
                  height="230"
                  rx="14"
                  fill="#ffffff"
                />

                {/* Card */}

                <rect
                  x="205"
                  y="135"
                  width="150"
                  height="90"
                  rx="14"
                  fill="#2563eb"
                />

                <circle
                  cx="235"
                  cy="180"
                  r="12"
                  fill="#93C5FD"
                />

                <circle
                  cx="252"
                  cy="180"
                  r="12"
                  fill="#BFDBFE"
                />

                <rect
                  x="220"
                  y="205"
                  width="80"
                  height="8"
                  rx="4"
                  fill="#ffffff"
                />

                {/* Chart */}

                <rect x="395" y="250" width="22" height="45" fill="#2563eb" />
                <rect x="430" y="220" width="22" height="75" fill="#60A5FA" />
                <rect x="465" y="180" width="22" height="115" fill="#3B82F6" />

                <polyline
                  points="205,285 255,250 305,265 355,210 405,185"
                  fill="none"
                  stroke="#2563eb"
                  strokeWidth="5"
                  strokeLinecap="round"
                />

                {/* Base */}

                <rect
                  x="130"
                  y="370"
                  width="440"
                  height="18"
                  rx="9"
                  fill="#94A3B8"
                />

              </svg>

            </div>

            {/* RIGHT CONTENT */}

            <div className="industry-content">

              <span className="section-tag">
                BANKING & FINANCE
              </span>

              <h2>
                Secure Digital Banking &
                <span> FinTech Solutions</span>
              </h2>

              <p>
                We develop modern banking and financial software that enables
                institutions to deliver secure, seamless, and intelligent digital
                experiences. From fintech startups to established financial
                organizations, our solutions enhance operational efficiency while
                maintaining the highest security standards.
              </p>

              <p>
                Our platforms support digital banking, payment processing, financial
                analytics, fraud prevention, loan management, and customer engagement,
                helping financial institutions innovate with confidence.
              </p>

              <div className="industry-features">

                <div>✓ Digital Banking Platforms</div>

                <div>✓ Payment Gateway Integration</div>

                <div>✓ FinTech Applications</div>

                <div>✓ Loan Management Systems</div>

                <div>✓ Fraud Detection</div>

                <div>✓ Financial Analytics</div>

                <div>✓ Mobile Banking Apps</div>

                <div>✓ Secure Transaction Processing</div>

              </div>

              <a href="/contact" style={{ textDecoration: "none", color: "inherit" }}>
                <button className="industry-btn">
                  Build Banking Solution →
                </button>
              </a>

            </div>

          </div>

        </section>

        {/* ================= EDUCATION SOLUTIONS ================= */}

        <section className="industry-detail education-section">

          <div className="container industry-detail-grid">

            {/* LEFT CONTENT */}

            <div className="industry-content">

              <span className="section-tag">
                EDUCATION INDUSTRY
              </span>

              <h2>
                Transforming Learning with
                <span> Smart Education Solutions</span>
              </h2>

              <p>
                VisionVote Technologies empowers educational institutions with modern
                digital platforms that simplify administration, improve collaboration,
                and create engaging learning experiences for students, educators, and
                administrators.
              </p>

              <p>
                Whether you're a school, college, university, coaching institute, or
                EdTech startup, our intelligent software solutions help streamline
                academic operations, automate processes, and enable learning anytime,
                anywhere.
              </p>

              <div className="industry-features">

                <div>✓ Learning Management System (LMS)</div>

                <div>✓ Student Information System</div>

                <div>✓ Online Examination Platform</div>

                <div>✓ Attendance Management</div>

                <div>✓ Faculty & Staff Portal</div>

                <div>✓ E-Learning Mobile Apps</div>

                <div>✓ Digital Library</div>

                <div>✓ Performance Analytics</div>

              </div>

              <a href="/contact" style={{ textDecoration: "none", color: "inherit" }}>
                <button className="industry-btn">
                  Build Education Platform →
                </button>
              </a>

            </div>

            {/* RIGHT SVG */}

            <div className="industry-image">

              <svg
                viewBox="0 0 700 520"
                xmlns="http://www.w3.org/2000/svg"
              >

                <defs>

                  <linearGradient
                    id="eduGradient"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                  >

                    <stop offset="0%" stopColor="#2563eb" />

                    <stop offset="100%" stopColor="#60a5fa" />

                  </linearGradient>

                </defs>

                <circle cx="570" cy="90" r="55" fill="#DBEAFE" />

                <circle cx="130" cy="430" r="70" fill="#E0F2FE" />

                {/* Laptop */}

                <rect
                  x="170"
                  y="90"
                  width="360"
                  height="240"
                  rx="20"
                  fill="url(#eduGradient)"
                />

                <rect
                  x="195"
                  y="115"
                  width="310"
                  height="190"
                  rx="12"
                  fill="#fff"
                />

                {/* Graduation Cap */}

                <polygon
                  points="350,145 285,175 350,205 415,175"
                  fill="#2563eb"
                />

                <rect
                  x="330"
                  y="205"
                  width="40"
                  height="22"
                  rx="4"
                  fill="#2563eb"
                />

                <line
                  x1="415"
                  y1="175"
                  x2="445"
                  y2="210"
                  stroke="#2563eb"
                  strokeWidth="5"
                />

                <circle
                  cx="445"
                  cy="220"
                  r="7"
                  fill="#2563eb"
                />

                {/* Books */}

                <rect
                  x="250"
                  y="245"
                  width="55"
                  height="14"
                  rx="7"
                  fill="#60A5FA"
                />

                <rect
                  x="315"
                  y="245"
                  width="70"
                  height="14"
                  rx="7"
                  fill="#93C5FD"
                />

                <rect
                  x="395"
                  y="245"
                  width="45"
                  height="14"
                  rx="7"
                  fill="#2563eb"
                />

                {/* Laptop Stand */}

                <rect
                  x="320"
                  y="330"
                  width="60"
                  height="40"
                  rx="8"
                  fill="#94A3B8"
                />

                <rect
                  x="240"
                  y="370"
                  width="220"
                  height="18"
                  rx="9"
                  fill="#64748B"
                />

              </svg>

            </div>

          </div>

        </section>

        {/* ================= RETAIL & ECOMMERCE ================= */}

        <section className="industry-detail retail-section">

          <div className="container industry-detail-grid">

            {/* LEFT SVG */}

            <div className="industry-image">

              <svg
                viewBox="0 0 700 520"
                xmlns="http://www.w3.org/2000/svg"
              >

                <defs>

                  <linearGradient
                    id="retailGradient"
                    x1="0%"
                    y1="0%"
                    x2="100%"
                    y2="100%"
                  >
                    <stop offset="0%" stopColor="#2563eb" />
                    <stop offset="100%" stopColor="#60a5fa" />
                  </linearGradient>

                </defs>

                <circle cx="565" cy="90" r="55" fill="#DBEAFE" />
                <circle cx="140" cy="430" r="70" fill="#E0F2FE" />

                {/* Store */}

                <rect
                  x="180"
                  y="140"
                  width="340"
                  height="220"
                  rx="18"
                  fill="url(#retailGradient)"
                />

                <rect
                  x="205"
                  y="170"
                  width="290"
                  height="165"
                  rx="12"
                  fill="#fff"
                />

                {/* Roof */}

                <polygon
                  points="170,140 350,80 530,140"
                  fill="#2563eb"
                />

                {/* Door */}

                <rect
                  x="320"
                  y="245"
                  width="60"
                  height="90"
                  rx="8"
                  fill="#60A5FA"
                />

                {/* Windows */}

                <rect
                  x="235"
                  y="205"
                  width="55"
                  height="45"
                  rx="8"
                  fill="#DBEAFE"
                />

                <rect
                  x="410"
                  y="205"
                  width="55"
                  height="45"
                  rx="8"
                  fill="#DBEAFE"
                />

                {/* Shopping Cart */}

                <polyline
                  points="470,105 495,105 510,155 560,155"
                  fill="none"
                  stroke="#2563eb"
                  strokeWidth="5"
                  strokeLinecap="round"
                />

                <circle cx="520" cy="175" r="10" fill="#2563eb" />
                <circle cx="555" cy="175" r="10" fill="#2563eb" />

              </svg>

            </div>

            {/* RIGHT CONTENT */}

            <div className="industry-content">

              <span className="section-tag">
                RETAIL & eCOMMERCE
              </span>

              <h2>
                Smart Retail &
                <span> eCommerce Solutions</span>
              </h2>

              <p>
                Modern retailers need seamless digital experiences that connect
                customers, inventory, sales, and operations. VisionVote Technologies
                develops innovative retail and eCommerce solutions that increase sales,
                enhance customer engagement, and optimize business operations.
              </p>

              <p>
                From online marketplaces and B2B/B2C commerce platforms to inventory
                management, POS systems, CRM, and AI-powered recommendations, we help
                businesses build scalable commerce ecosystems for the digital age.
              </p>

              <div className="industry-features">

                <div>✓ eCommerce Websites</div>

                <div>✓ Multi-Vendor Marketplace</div>

                <div>✓ POS Systems</div>

                <div>✓ Inventory Management</div>

                <div>✓ CRM Solutions</div>

                <div>✓ Payment Gateway Integration</div>

                <div>✓ Loyalty Programs</div>

                <div>✓ Sales Analytics</div>

              </div>

              <a href="/contact" style={{ textDecoration: "none", color: "inherit" }}>
                <button className="industry-btn">
                  Build Retail Solution →
                </button>
              </a>
            </div>

          </div>

        </section>

        {/* ================= CTA ================= */}

        <section className="industry-cta">

          <div className="container">

            <div className="industry-cta-box">

              <div className="cta-content">

                <span className="cta-tag">
                  LET'S BUILD THE FUTURE TOGETHER
                </span>

                <h2>
                  Ready to Transform
                  <span> Your Industry?</span>
                </h2>

                <p>
                  Whether you're a startup looking to launch your next big idea or an
                  established enterprise aiming to modernize operations, VisionVote
                  Technologies delivers innovative software solutions tailored to your
                  industry's unique challenges.
                </p>

                <p>
                  Our team combines expertise in software development, AI, cloud
                  technologies, automation, and digital transformation to build secure,
                  scalable, and future-ready solutions that accelerate business growth.
                </p>

                <div className="cta-features">

                  <div>✓ Free Consultation</div>

                  <div>✓ Custom Software Strategy</div>

                  <div>✓ AI & Automation</div>

                  <div>✓ Cloud Solutions</div>

                  <div>✓ Dedicated Development Team</div>

                  <div>✓ Long-Term Technical Support</div>

                </div>

                <div className="cta-buttons">

                  <a href="/contact" style={{ textDecoration: "none", color: "inherit" }}>
                    <button className="cta-primary">
                      Start Your Project
                    </button>
                  </a>
                  <a href="/contact" style={{ textDecoration: "none", color: "inherit" }}>
                    <button className="cta-secondary">
                      Contact Our Experts
                    </button>
                  </a>

                </div>

              </div>

              {/* Right Side */}

              <div className="cta-illustration">

                <svg
                  viewBox="0 0 600 500"
                  xmlns="http://www.w3.org/2000/svg"
                >

                  <defs>

                    <linearGradient
                      id="ctaGradient"
                      x1="0%"
                      y1="0%"
                      x2="100%"
                      y2="100%"
                    >

                      <stop offset="0%" stopColor="#2563eb" />

                      <stop offset="100%" stopColor="#60a5fa" />

                    </linearGradient>

                  </defs>

                  <circle
                    cx="500"
                    cy="80"
                    r="60"
                    fill="#DBEAFE"
                  />

                  <circle
                    cx="120"
                    cy="420"
                    r="70"
                    fill="#E0F2FE"
                  />

                  <rect
                    x="130"
                    y="80"
                    width="340"
                    height="260"
                    rx="22"
                    fill="url(#ctaGradient)"
                  />

                  <rect
                    x="155"
                    y="105"
                    width="290"
                    height="210"
                    rx="14"
                    fill="#fff"
                  />

                  <circle
                    cx="300"
                    cy="185"
                    r="55"
                    fill="#2563eb"
                  />

                  <polygon
                    points="290,160 340,185 290,210"
                    fill="#ffffff"
                  />

                  <rect
                    x="210"
                    y="265"
                    width="180"
                    height="12"
                    rx="6"
                    fill="#DBEAFE"
                  />

                  <rect
                    x="240"
                    y="290"
                    width="120"
                    height="12"
                    rx="6"
                    fill="#BFDBFE"
                  />

                  <rect
                    x="250"
                    y="340"
                    width="100"
                    height="16"
                    rx="8"
                    fill="#94A3B8"
                  />

                  <rect
                    x="180"
                    y="360"
                    width="240"
                    height="18"
                    rx="9"
                    fill="#64748B"
                  />

                </svg>

              </div>

            </div>

          </div>

        </section>



      </div>
      <Footer />
    </>

  );
};

export default Industries;